import React, { useState } from 'react'
import Price from '../Price/Price'
import RefinedBrands from '../Brands/RefinedBrands'
import MobileClearRefinements from '../CurrentRefinement/MobileClearRefinements'
import { getParameter } from '../../functions/getAlgoliaFilter'
import icons from '../../assets/BuildIcons/Icons'
import FilterIcon from '../../assets/FilterIcon.svg'
import CancelIcon from '../../assets/CancelIcon.svg'
import './MobileFilter.scss'
import { t } from 'i18next'

const MobileFilter = () => {
  const win = window
  const [filter, setFilter] = useState(false)
  const localhost = win.location.hostname === 'localhost'
  const brandParam = getParameter("brand") !== null

  return (
    <div className="mobileFilter">
      {filter && <div className="mobileFilter_backDrop" />}
      <div>
        <button
          className="sortButton"
          style={{ border: 'none', backgroundColor: 'white' }}
          onClick={() => setFilter(!filter)}
        >
          <div className="mobileFilterLabel">
            <span>
              <img
                src={localhost ? FilterIcon : icons.filterIcon}
                alt="filterIcon"
              />
            </span>
            <span>{t('filter')}</span>
          </div>
        </button>
      </div>
      <div
        className="mobileFilterOptions"
        style={{ display: filter ? 'block' : 'none' }}
      >
        <div>
          <div className="mobileFilterTitle">{t('filter')}</div>
          <div
            className="filterCancel"
            onClick={() => {
              setFilter(false)
            }}
          >
            <img
              src={localhost ? CancelIcon : icons.cancelIcon}
              alt="cancelIcon"
            />
          </div>
        </div>
        <Price />
        {brandParam ? <></> : <RefinedBrands attribute="DeviceManufacturer" />}
        <div className="filterBtns">
          <MobileClearRefinements />
          <button className="mobileApplyBtn">
            <span
              className="mobileApplyBtnText"
              onClick={() => {
                setFilter(false)
              }}
            >
              {t('apply_filters')}
            </span>
          </button>
        </div>
      </div>
    </div>
  )
}

export default MobileFilter
